var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar",class:{'is-inline': _vm.inline, 'is-community': _vm.$route.meta.isCommunity},style:({'marginLeft': _vm.marginLeft})},[_c('div',{staticClass:"inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }